// export const tierNameMap = {
//   STANDARD: '普卡',
//   SELECT: '飞行卡',
//   SILVER: '银卡',
//   GOLDEN: '金卡',
//   PLATINUM: '白金卡',
//   'PM-SILVER': '体验银卡',
//   'PM-GOLDEN': '体验金卡',
//   'PM-PLATINUM': '体验白金卡',
//   'FXT-SILVER': '体验银卡-飞行通',
//   'FXT-GOLDEN': '体验金卡-飞行通',
//   'FXT-PLATINUM': '体验白金卡-飞行通'
// }

export const tierNameMap = {
  STANDARD: '普卡',
  SELECT: '飞行卡',
  SILVER: '银卡',
  GOLDEN: '金卡',
  PLATINUM: '白金卡',
  'PM-SILVER': '银卡',
  'PM-GOLDEN': '金卡',
  'PM-PLATINUM': '白金卡',
  'FXT-SILVER': '银卡',
  'FXT-GOLDEN': '金卡',
  'FXT-PLATINUM': '白金卡'
}

export const tierNameImageMap = {
  STANDARD: 'STANDARD',
  SELECT: 'SELECT',
  SILVER: 'SILVER',
  GOLDEN: 'GOLDEN',
  PLATINUM: 'PLATINUM',
  'PM-SILVER': 'SILVER',
  'PM-GOLDEN': 'GOLDEN',
  'PM-PLATINUM': 'PLATINUM',
  'FXT-SILVER': 'SILVER',
  'FXT-GOLDEN': 'GOLDEN',
  'FXT-PLATINUM': 'PLATINUM'
}

export const userTypeMap = {
  0: 'USER',
  1: 'AGENT',
  2: 'AGENT',
  3: 'CARRIER'
}
